module.exports = __webpack_public_path__ + "img/check.31e29acc.svg";